import { useContext } from 'react';
import { HealthCheckOverviewContext } from '../Contexts/HealthCheckOverviewContext';

export const useHealthCheckOverview = () =>
  useContext(HealthCheckOverviewContext);
